import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

/**
 * The booking calendar a coach's booking page embeds. The public coach read
 * carries only whether a calendar exists, so the id stays off every other page.
 */
export const getBookingCalendarId = createServerFn({ method: "GET" })
  .validator(z.object({ username: z.string() }))
  .handler(async ({ data }): Promise<string | null> => {
    const { getPublicBookingCalendarId } =
      await import("~/lib/server/coach-visibility");
    return getPublicBookingCalendarId(data.username);
  });
